module.exports = __webpack_public_path__ + "static/media/2.57d5c650.png";